import { AfterViewInit, 
        Component,
         ElementRef,
         Input,
         OnChanges,
         OnInit, 
         SimpleChanges, 
         ViewChild} from '@angular/core';

import { NgOptimizedImage } from '@angular/common'
// import { Cloudinary, CloudinaryImage } from '@cloudinary/url-gen';
// import { fill, scale } from "@cloudinary/url-gen/actions/resize";

// import {
//   accessibility,
//   responsive,
//   lazyload,
//   placeholder
//  } from '@cloudinary/ng';

// import { SocialAuthService,
//          GoogleLoginProvider,
//          SocialUser } from '@abacritt/angularx-social-login';

// import { takeUntil } from 'rxjs/operators';

// import { ApiService, AppHelper,
//          AuthService,
//          CookieService,
//          PageHelper, 
//          User,
//          WindowService } from 'src/app/_core/index'
// import { Router } from '@angular/router';


@Component({
  selector: 'ss-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit, AfterViewInit, OnChanges {

  @Input('src') srcIn: any
  @Input('imageID') imageID: string
  @Input('imageAR') imageAR: number
  @Input('title') title: any

  @Input('hideShroud') hideShroud: boolean = true // false

  ngOptimizedImage: NgOptimizedImage

  src: any
  plugins: any

  srcset: string

  constructor(
  ) { }


  // cloudImg: CloudinaryImage

  ngOnInit(): void {
    // this.update()

    this.update()
    // console.log('cloudImg', this.cloudImg.toURL(), this.cloudImg)
  }

  ngAfterViewInit(): void {
    // this.update()
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.update()
  }

  update() {
    window.setTimeout(this.updateImageNow.bind(this), 100)
  }

  updateImageNow() {
    console.log('TODO: banner.component updateImageNow')
    // FROM oak-park
    // if (!this.imageID) return this.hideShroud = true

    // // let aspectRatio:number = this.imageAR
    // // this.src = this.cloudImg.resize(scale().width(window.innerWidth).height(Math.ceil(window.innerWidth / aspectRatio))).toURL();
    
    // // https://cloudinary.com/documentation/responsive_images
    // // https://cloudinary.com/documentation/responsive_html
    // this.srcset = ` 
    //   https://res.cloudinary.com/oak-park-wedding-gown-cleaners/image/upload/f_auto/q_auto/c_scale,w_256/${ this.imageID } 256w,
    //   https://res.cloudinary.com/oak-park-wedding-gown-cleaners/image/upload/f_auto/q_auto/c_scale,w_512/${ this.imageID } 512w,
    //   https://res.cloudinary.com/oak-park-wedding-gown-cleaners/image/upload/f_auto/q_auto/c_scale,w_768/${ this.imageID } 768w,
    //   https://res.cloudinary.com/oak-park-wedding-gown-cleaners/image/upload/f_auto/q_auto/c_scale,w_1024/${ this.imageID } 1024w,
    //   https://res.cloudinary.com/oak-park-wedding-gown-cleaners/image/upload/f_auto/q_auto/c_scale,w_1280/${ this.imageID } 1280w `

    // this.src = 'https://res.cloudinary.com/oak-park-wedding-gown-cleaners/image/upload/f_auto/q_auto/c_scale,w_512/${ this.imageID }'

    // console.log('TODO: update-image-from-window-size', this.srcIn, window.innerWidth, this.src)
    // this.plugins = [lazyload(), placeholder()]
    // this.plugins = [placeholder()]
  }


}
